<template>
  <b-modal
    id="addautogeneratecode"
    size="md"
    ref="addautogeneratecode"
    body-class="bg-white"
    cancel-title="Close"
    cancel-variant="light"
    :ok-title-html="submitted==true?loaderIcon+'Save':'Save'"
    ok-title="Save"
    :no-close-on-backdrop="true"
    title="Auto Generated Code"
    @ok.prevent="handleOk"
    @shown="field.prefix='',field.suffix = ''"
    :ok-disabled="submitted"
  >
    <b-form-group>
      <b-alert class="alert-transparent alert-danger" :show="duplicate ">
        <p class="text-danger">{{message}}</p>
      </b-alert>
      <b-alert class="alert-transparent alert-danger" :show="error_show && this.errors.any()">
        <p class="text-danger" v-if="errors.has('prefix')">{{ errors.first('prefix') }}</p>
        <p class="text-danger" v-if="errors.has('suffix')">{{ errors.first('suffix') }}</p>
      </b-alert>
      <b-row>
        <b-col lg="12">
          <label for="code" class="required">Prefix and Suffix</label>
          <div class="display-flex">
            <b-form-input
              type="text"
              size="sm"
              class="mr-2"
              name="prefix"
              placeholder="Prefix"
              v-model.trim="field.prefix"
              v-validate="'required|max:10'"
            />
            <b-form-input
              class="ml-2"
              type="text"
              size="sm"
              placeholder="Suffix"
              name="suffix"
              v-model.trim="field.suffix"
              v-validate="'required|max:15|min_value:0|numeric'"
            />
          </div>
        </b-col>
      </b-row>
    </b-form-group>
  </b-modal>
</template>
<script>
import store from "@/store/index";
import { mapState } from "vuex"; // get data set in the state in vuex
import { notificationMixin } from "@/mixins/notification";

export default {
  props: ["type"],
  mixins: [notificationMixin],
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      duplicate: false,
      error_show: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      field: {
        prefix: "",
        suffix: "",
        type: this.type
      }
    };
  },

  methods: {
    getPresentValue(arr, prop, val, field) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i][field];
          break;
        }
      }
      return hasMatch;
    },
    async handleOk() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submitted = true;
          store.dispatch("general/addautocode", this.field).then(() => {
            if (this.code == 200) {
              this.$refs.addautogeneratecode.hide();
              this.submitted = false;
              this.$emit("setCodeValue", {
                code_id: this.updated_id,
                prefix: this.field.prefix,
                suffix: this.field.suffix
              });
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: this.message,
                type: this.message_type,
                showCloseButton: true
              });
            } else {
              this.duplicate = true;
              this.submitted = false;
              this.error_show = true;
            }
          });
        } else {
          this.submitted = false;
          this.error_show = true;
        }
      });
    }
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      updated_id: state => state.general.updated_id,
      code: state => state.general.code,
      message: state => state.general.message,
      message_type: state => state.general.message_type
    })
  }
};
</script>
<style>
.required:after {
  color: #e32;
  content: " *";
  display: inline;
}
</style>